<!-- views/Login.vue -->
<template>
  <var-space justify="center" align="center" class="login-page" :size="0" direction="column">
    <var-paper :elevation="8" class="login-box" radius="12">
      <var-space direction="column" :size="16" class="login-content">
        <!-- 标题 -->
        <var-space direction="column" :size="4" align="center">
          <h1 style="font-size: 24px; font-weight: 600; color: #333; margin: 0;">
            📋 客户款式台账系统
          </h1>
          <p style="font-size: 13px; color: #999; margin: 0;">
            请输入用户名和密码进入系统
          </p>
        </var-space>

        <!-- Tabs -->
        <var-tabs v-model:active="activeTab" class="login-tabs">
          <var-tab name="login">登录</var-tab>
          <var-tab name="register">注册</var-tab>
        </var-tabs>

        <!-- 登录表单 -->
        <div v-if="activeTab === 'login'">
          <var-space direction="column" :size="12" fill>
            <var-input v-model="loginForm.username" placeholder="请输入用户名" clearable />
            <var-input v-model="loginForm.password" type="password" placeholder="请输入密码" clearable />
            <p v-if="loginError" style="color: #f56c6c; font-size: 13px; margin: 0;">
              {{ loginError }}
            </p>
            <var-button type="primary" block :loading="loginLoading" @click="handleLogin">
              进入系统
            </var-button>
          </var-space>
        </div>

        <!-- 注册表单 -->
        <div v-else>
          <var-space direction="column" :size="12" fill>
            <var-input v-model="registerForm.company" placeholder="请输入公司名称" clearable />
            <var-input v-model="registerForm.username" placeholder="请设置用户名" clearable />
            <var-input v-model="registerForm.password" type="password" placeholder="至少6位" clearable />
            <var-input v-model="registerForm.confirmPassword" type="password" placeholder="请再次输入密码" clearable />
            <p v-if="registerError" style="color: #f56c6c; font-size: 13px; margin: 0;">
              {{ registerError }}
            </p>
            <var-button type="primary" block :loading="registerLoading" @click="handleRegister">
              立即注册
            </var-button>
            <p style="font-size: 13px; color: #909399; text-align: center; margin: 0;">
              💡 首个注册用户自动成为管理员
            </p>
          </var-space>
        </div>
      </var-space>
    </var-paper>
  </var-space>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { Snackbar } from '@varlet/ui'
import { useAppStore } from '@/stores'
import { authApi } from '@/api'

const router = useRouter()
const route = useRoute()
const appStore = useAppStore()

const activeTab = ref('login')

const loginForm = ref({ username: '', password: '' })
const registerForm = ref({
  username: '',
  password: '',
  confirmPassword: '',
  company: '',
})

const loginError = ref('')
const registerError = ref('')
const loginLoading = ref(false)
const registerLoading = ref(false)

async function handleLogin() {
  loginError.value = ''
  loginLoading.value = true

  try {
    const data = await authApi.login(loginForm.value.username, loginForm.value.password)
    if (data && data.success) {
      appStore.setCurrentUser(loginForm.value.username)
      appStore.setCurrentUserInfo(data.user)
      appStore.isLoggedIn = true
      Snackbar.success('登录成功，欢迎回来！')

      // ✅ 登录后跳回 redirect，默认 /production
      const redirect = route.query.redirect || '/production'
      router.replace(redirect)
    } else {
      loginError.value = data?.msg || '用户名或密码错误'
    }
  } catch (err) {
    loginError.value = '服务连接失败，请检查网络'
  } finally {
    loginLoading.value = false
  }
}

async function handleRegister() {
  registerError.value = ''

  if (registerForm.value.password.length < 6) {
    registerError.value = '密码至少6位'
    return
  }

  if (registerForm.value.password !== registerForm.value.confirmPassword) {
    registerError.value = '两次输入的密码不一致'
    return
  }

  registerLoading.value = true

  try {
    const data = await authApi.register(
      registerForm.value.username,
      registerForm.value.password,
      registerForm.value.company
    )

    if (data && data.success) {
      Snackbar.success('注册成功！请登录')
      activeTab.value = 'login'
      loginForm.value.username = registerForm.value.username
      loginForm.value.password = ''
      registerForm.value = { username: '', password: '', confirmPassword: '', company: '' }
    } else {
      registerError.value = data?.msg || '注册失败'
    }
  } catch (err) {
    registerError.value = '服务连接失败，请检查网络'
  } finally {
    registerLoading.value = false
  }
}
</script>

<style scoped>
.login-page {
  position: fixed;
  inset: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  z-index: 10000;
}

.login-box {
  width: 400px;
  max-width: 92vw;
  max-height: 90vh;
  overflow-y: auto;
  padding: 32px 36px;
}

.login-content {
  width: 100%;
}

.login-tabs {
  width: 100%;
}

@media (max-width: 480px) {
  .login-box {
    padding: 24px 20px;
  }
}
</style>